import { _js } from '@ifixit/localize';
import { TiptapButton } from '../TiptapButton';
import { faOutdent } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEditorContext } from '../../editor_context';

export const UnindentButton = () => {
   const { editor } = useEditorContext();

   if (editor.isDestroyed) {
      return null;
   }

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().liftListItem('listItem').run()}
         isDisabled={!editor.can().liftListItem('listItem')}
         icon={<FontAwesomeIcon icon={faOutdent} />}
         title={_js('Decrease indent')}
         overrideShortcut={'shift+tab'}
      />
   );
};
